module.exports = __webpack_public_path__ + "img/pass_type_SingleRide.a82d8cea.jpg";